import { Caption, Flex, Subheader } from '@archipro-design/aria';
import { ErrorWarningFill } from '@archipro-design/icons';

const UploadErrorTile = ({
    errorMsg,
    css,
}: {
    errorMsg: string;
    css?: string;
}) => {
    return errorMsg ? (
        <Flex className={css}>
            <Flex>
                <ErrorWarningFill />
                <Subheader>{`Can't upload.`}</Subheader>
            </Flex>
            <Caption>{errorMsg}</Caption>
        </Flex>
    ) : null;
};

export default UploadErrorTile;
